import { Inbox } from 'lucide-react';
import { problemText } from '@/shared/api/problemText';
import { useApiProblem } from '@/shared/api/useApiProblem';
import { SurfaceLoadError, SurfaceLoading } from '@/shared/components';

/** Laden, Ladefehler und Leer der Liste — ein Fehler heißt nie „keine Unterhaltungen“. */
export function ThreadListState({
  loading,
  paused,
  error,
  onRetry,
  awaitingOnly,
  filtered,
}: {
  loading?: boolean;
  paused?: boolean;
  error?: unknown;
  onRetry?: () => void;
  awaitingOnly: boolean;
  filtered: boolean;
}) {
  const problem = useApiProblem(error ?? null);
  if (loading) return <SurfaceLoading label="Unterhaltungen werden geladen" rows={6} />;
  if (paused) {
    return (
      <p role="status" className="text-ink-soft px-6 py-10 text-center text-sm">
        Keine Verbindung. Die Unterhaltungen laden, sobald sie zurück ist.
      </p>
    );
  }
  if (error) {
    return (
      <SurfaceLoadError
        message={problemText(problem, 'Die Unterhaltungen konnten nicht geladen werden.')}
        onRetry={problem?.status === 403 ? undefined : onRetry}
        retrying={false}
      />
    );
  }
  const title = awaitingOnly ? 'Nichts wartet auf eine Antwort' : 'Keine Unterhaltungen';
  const hint = filtered
    ? 'Für diesen Kanal gibt es hier nichts. „Alle Kanäle“ zeigt den Rest.'
    : awaitingOnly
      ? 'Alles beantwortet. „Alle“ zeigt jede Unterhaltung.'
      : 'Sobald ein Gast über einen Kanal schreibt, erscheint er hier.';
  return (
    <div className="text-ink-faint flex flex-col items-center gap-2 px-6 py-10 text-center">
      <Inbox size={26} strokeWidth={1.5} aria-hidden />
      <p className="text-ink text-sm font-semibold">{title}</p>
      <p className="text-ink-soft text-xs">{hint}</p>
    </div>
  );
}
